import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { getCMSUrlToPromotions } from '../../constants/cms-urls';

const mapStateToProps = (state) => ({
  menuPromotions: state.MenuPromotions.menuPromotions,
  storefront : state.Manage.storefront,
  travelInformation: state.TravelInformation.travelInformation,
});
class HeaderAccordionAnimated extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kindPromotions:'',
    };
  }
  render() {
    const {
      handleExpandArrowClick,
      isExpanded,
      renderContent,
      storefront,
      titleColumn,
    } = this.props;

    const accordionWrapper = cx(
      'HeaderAccordionSwitch',
      { 'HeaderAccordionSwitch--open': isExpanded,
        'HeaderAccordionSwitch--close': !isExpanded,
      },
    );
    
    return (
      <section className={ accordionWrapper }>
        <div
          className='HeaderMenuHamburger-linksTitle'
          onClick={ handleExpandArrowClick }
        >{ titleColumn }
          { isExpanded ? <span className='Icon Icon--arrowSmallUp'></span> : <span className='Icon Icon--arrowSmallDown'></span> }
        </div>
        <ul className='HeaderMenuHamburger-promotionsLinks'>
          {
            renderContent.map((option, index) => {
              if (option.centerLinkUrl) {
                const urlOptions = (option.centerLinkUrl).includes('https');
              
                return (
                  <li className='HeaderMenuHamburger-item' key={ ` option_${ index }` }>
                    <a
                      className='HeaderMenuPromotions-link'
                      onClick={ () => this.trackMenuClick({ i: index, value: option.centerLinkUrl }) }
                      href={ urlOptions ? option.centerLinkUrl : getCMSUrlToPromotions(storefront, option.centerLinkUrl) } 
                    >
                      { option.centerLinkCta }
                    </a>
                  </li>
                );
              }
            })
          }
        </ul>
      </section>
    );
  }
  
  trackMenuClick = ( urlId ) => {
    const { value } = urlId;
    this.setState({
      kindPromotions: value,
    });
  };
}

export default connect (mapStateToProps)(HeaderAccordionAnimated);